import {useDispatch} from 'react-redux'
import {updateTrainerPermissions} from '../users/usersSlice'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import Card from 'react-bootstrap/Card'

import classes from "./Settings.module.css"

import {useGymTrainers}  from '../users/hooks'

export default function TrainerPermissions () {
	const dispatch = useDispatch()

	const {status,trainers} = useGymTrainers()
	
	const handleEditPermissions = (spec,update)=>{
		const payload = {update}
		if(spec==='apply_to_all_trainers'){
			payload.apply_to_all_trainers = 1
		}else{
			payload.trainer_ids = [spec]
		}

		dispatch(updateTrainerPermissions(payload))
	}


	return (
		<Card className={`${classes.cardWidth} mb-5 shadow px-5`}>
			<Card.Body>
				<h4>Trainer Permissions</h4>
				<hr class="mt-1 mb-4" />
				{status==='pending'&&<Spinner animation="border"/>}
				{status==='idle'&&
					<Table striped size="sm">
						<tbody>
							<tr>
								<th>Trainer</th>
								<th>
									<OverlayTrigger overlay={
										<Tooltip>
											Allow trainers to manage client billing and charge clients using their card on file.
										</Tooltip>
									}>
										<i className="fa fa-info-circle mr-1" />
									</OverlayTrigger>
									Manage Billing
								</th>
							</tr>
							{trainers.map(trainer=>(
								<tr>
									<td>
										{trainer.user_name}
									</td>
									<td>
										<Form.Check
											onChange={e=>{
												handleEditPermissions(
													trainer.user_id_number,
													{manage_billing:Number(e.target.checked)}
												)
											}}
											checked={
												Boolean(trainer.permissions.manage_billing)
											}
											label="Billing"
											id={`manage-billing-check-${trainer.user_id_number}`}
										/>
									</td>
								</tr>
							))}
						</tbody>
					</Table>
				}
			</Card.Body>
		</Card>
	)
}